import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import Popover from '@material-ui/core/Popover';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 'calc(100% - 70px)',
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    padding: 20,
    boxShadow: 'none',
    display: 'flex',
    pointerEvents: 'all',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  root: {
    pointerEvents: 'none',
  },
}));

const HintPopup = ({ open, onClose, children, anchorPosition }) => {
  const classes = useStyles();
  if (!anchorPosition) {
    anchorPosition = {
      top: window.innerHeight * 0.56,
      left: window.innerWidth * 0.2,
    };
  }
  return (
    <Popover
      open={open}
      onClose={onClose}
      TransitionComponent={Fade}
      classes={{
        root: classes.root,
        paper: classes.paper,
      }}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      hideBackdrop
    >
      <IconButton
        className={classes.closeButton}
        color="inherit"
        aria-label="close"
        component="span"
        size="small"
        onClick={onClose}
      >
        <Close />
      </IconButton>
      {children}
    </Popover>
  );
};

HintPopup.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  anchorPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }),
};

export default HintPopup;
